import React,{useState} from "react"
import "./App.css"
// import Navigation from "./components/Naviggation/Navigation"
// import Header from "./components/Header/Header"
import 'remixicon/fonts/remixicon.css'

import Home from "./Home/Home"
import Cart from "./components/Cart/Cart"
import Navbar from "./components/Naviggation/Navigation"
import {

  Routes,
  Route,
} from "react-router-dom";

function App() {
   
  
  return (
    <>
    <Routes>
    <Route path="/" element={<Navbar/>}>
        <Route index element={<Home />} />
        <Route path="dishes" element={<div>Not found dishes</div>}/>
        <Route path="about" element={<div>Not found about</div>}/>
        <Route path="menu" element={<div>Not found menu</div>}/>
        <Route path="review" element={<div>Not found rewwiew</div>}/>
        <Route path="order" element={<div>Not found order</div>}/>
        <Route path="login" element={<div>Not found login</div>}/>
        <Route path="cart" element={<Cart/>}/>
      </Route>
  

 
    </Routes>
    </>
  )
}

export default App
